import api from '../../api/api_resource'

const state = {
    ids: [],
    reasons: [],
    all: [],
    current_page: 1,
    per_page: 100,
    from: 1,
    to: 100,
    last_page: null,
    total: null,
};

// getters
const getters = {
    all: s => s.all,
    reasons: s => s.reasons,
    ids: s => s.ids,
    getCurrentPage: s => s.current_page,
    getPerPage: s => s.per_page,
};

// actions
const actions = {
    getList({ commit, state }, args) {
        return new Promise((success, error) => {
            if(args && args.sort_asc !== undefined) {
                args.sort_asc = args.sort_asc ? 1 : 0;
            }
            const search_args = Object.assign({
                page: state.current_page,
                per_page: state.per_page,
            }, args);
            api.index('claims', search_args).then(list => {
                commit('setList', list);
                success(list);
            }).catch(error);
        });
    },
    searchVehicle({ commit, state }, term) {
        return new Promise((success, error) => {
            api.get('claims.search-vehicle', [], {term}).then(list => {
                success(list);
            }).catch(error);
        });
    },
    store({ commit, state }, args) {
        return new Promise((success, error) => {
            const search_args =  args.data;
            api.store('claims', search_args).then(user => {
                success(user);
            }).catch(errors => {
                error(errors.response.data);
            });
        });
    },
    delete({ commit, state }, user_id) {
        return new Promise((success, error) => {
            api.destroy('claims', user_id.id).then(user => {
                success(user);
            }).catch(errors => {
                error(errors.response.data);
            });
        });
    },
    update({ commit, state }, args) {
        return new Promise((success, error) => {
            api.update('claims', args, args.id).then(user => {
                success(user);
            }).catch(errors => {
                error(errors);
            });
        });
    },
};

// mutations
const mutations = {
    setList (state, result) {
        console.log('result', result)
        state.all = result.data;
        state.total = result.total;
        state.last_page = result.last_page;
        state.from = result.from || 0;
        state.to = result.to || 0;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
    },
    setReasons (state, result) {
        state.reasons = result.reasons;
    },
    setPage(state, page) {
        state.current_page = page
    },
    setPerPage(state, page) {
        state.per_page = page
    },
    setCurrentPage(state, page) {
        state.current_page = page
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/claims.js